











































































import { Component, Watch } from 'vue-property-decorator';
import MyDoneServices from '@/services/mydone';
import { getRange } from '@/libs/time';
import AlertDetail from '../todo/alert-detail.vue';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import PageMixin from '@/mixins/page-mixin';
import AlertData from '../full/alert-data.vue';
@Component({
  components: { AlertDetail, AlertData }
})
export default class Todo extends mixins(DictMixin, PageMixin) {
  todoSrv = new MyDoneServices();
  created() {
    this.getAll();
  }

  count: any = {};
  async getAll() {
    let [startTime, endTime] = this.date;
    this.loading = true;
    this.count = await this.todoSrv.getReviewCount({ startTime, endTime });
    this.params = { startTime, endTime };
    await this.getList();
    this.loading = false;
  }

  params: any = {};

  async getList() {
    let res = await this.todoSrv.getReviewPage({ ...this.params, page: this.page, limit: this.limit });
    this.dataSource = res.list.map((v: any) => {
      return {
        ...v,
        ...v.sourceAsMap
      };
    });
    this.total = res.totalCount;
  }

  async getCurrentList(type: number) {
    this.page = 1;
    this.loading = true;
    let [startTime, endTime] = this.date;
    if (type === 0) {
      this.params = { startTime, endTime, alertReviewStatus: 1 };
    } else {
      this.params = { endTime, reviewDate: endTime };
    }
    this.getList();
    this.loading = false;
  }

  date: any = getRange('total');
  @Watch('date')
  onDateChange() {
    this.getAll();
  }

  pagination = { showTotal: () => `共 ${this.dataSource.length} 条` };
  columns = [
    { title: '预警编号', dataIndex: 'alertCode' },
    { title: '触发决策模型名称', dataIndex: 'ruleName' },
    { title: '预警消息', dataIndex: 'alertMessage' },
    { title: '数据数量', width: 120, dataIndex: 'alertCount' },
    {
      title: '预警等级',
      dataIndex: 'alertLevel',
      scopedSlots: {
        customRender: 'alertLevel'
      }
    },
    { title: '预警日期', dataIndex: 'alertDate' },
    { title: '复核期限', dataIndex: 'alertReviewDueDate' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 140,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];

  visible: boolean = false;
  detail: any = {};
  logs: any = {};
  async openDetail(record: any) {
    let res = await this.todoSrv.getInfo(record.alertCode);
    this.detail = res.alertInfoSource || record;
    this.logs = res;
    this.visible = true;
  }

  infos: any = {};
  dataVisible: boolean = false;
  async openAlertData(record: any) {
    this.infos = record;
    this.dataVisible = true;
  }

  bodyStyle = { backgroundColor: '#EEE'};
}
